export default "__VITE_ASSET__CkB3vDD1__"